import format from 'date-fns/format';
//import markdownIt from 'markdown-it';
//import markdownItSup from 'markdown-it-sup';
//import markdownItSanitizer from 'markdown-it-sanitizer';
//import markdownItClass from '@toycode/markdown-it-class';
//import markdownItLinkAttributes from 'markdown-it-link-attributes';
//import linkifyIt from 'linkify-it';
import { ElementType } from 'react';
import { InternalMediaButton, MessageTypes } from 'src/store/types';
import { GlobalState } from 'src/store/types';
import { useSelector } from 'react-redux';
import Linkify from 'react-linkify'
import './styles.scss';
import { AnyFunction } from 'src/utils/types';

type Props = {
  message: MessageTypes;
  customComponent?: ElementType;
  showTimeStamp: boolean;
  onInteractiveButtonClicked?: AnyFunction;
};

function Message({ message, customComponent, showTimeStamp, onInteractiveButtonClicked }: Props) {
  const CustomComponent = message.props;
  const themeColor = useSelector((state: GlobalState) => state.responses.themeColor);
  const textColor = useSelector((state: GlobalState) => state.responses.textColor);
  const backgroundColor = message.sender === 'client' ? `#${themeColor}` : '';
  const color = message.sender === 'client' ? textColor : '';

  const getInternalMediaButtonsToRender = (button: InternalMediaButton) => {
    const ComponentToRender = button.component;
    return (
      <ComponentToRender
        onInteractiveButtonClicked={onInteractiveButtonClicked}
        button={button}
      />
    );
  };
  return (
    <div className={`rcw-${message.sender}`}>
      {message.props ? (
        <CustomComponent />
      ) : (
        <Linkify
          componentDecorator={(decoratedHref, decoratedText, key) => (
            <a target="blank" href={decoratedHref} key={key}>
              {decoratedText}
            </a>
          )}
        >
          <div className="rcw-message-text" style={{ backgroundColor, color }}>
            {message.text}
            {message.internalMediaButton && (
              <div className="internal-media-buttons">
                {message.internalMediaButton.prefix && (
                  <div className="internal-media-buttons__prefix">
                    {message.internalMediaButton.prefix}
                  </div>
                )}
                {message.internalMediaButton.buttons.map((internalMediaButton) => (
                  <div className="internal-media-buttons__button" key={`internalMediaButton-${message.customId ?? ''}-${internalMediaButton.label}`}>
                    {getInternalMediaButtonsToRender(internalMediaButton)}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Linkify>
      )}
      {showTimeStamp && (
        <span className="rcw-timestamp">
          {message.customTimeStamp ? message.customTimeStamp : format(message.timestamp, 'HH:mm')}
        </span>
      )}
    </div>
  );
}

export default Message;
